import React from "react";
import { Button, Input } from "@material-ui/core";
import { isDate } from '../../../../helpers/isDate';
import TableComponent, { TableOp } from "../../../../components/table/TableOps";
import { withRouter } from "react-router-dom";
import moment from "moment";
import Http from "../../../../Http";
import ACCESS from "../../../../ACCESS";

class FacturasClientes extends TableComponent {
  componentDidMount() {
    this.tableConfig(
      {
        dataUrl: `factura-cliente/filter-facturas/${this.props.idFolio}`,
        deleteUrl: "factura-cliente/delete-factura",
        deleteField: "folio",
        // modUrl: "/Cobranza/FacturaCliente/:id?",
      },
      TableOp.Table(
        false,
        [
          { label: "Folio Factura", id: "folio" },
          // { label: "Cliente", id: "cliente" },
          { label: "Usuario", id: "usuario" },
          { label: "Fecha", id: "createdAt" },
          // { label: "Tipo", id: "tipo" },
        ],
        [{ id: 'delete', icon: 'delete', access: [ACCESS.COBRANZA_FACTURAS_POR_CLIENTE.CREAR_FOLIO] },]
      )
    );
    this.table();
  }

  componentDidUpdate(prevprops) {
    if (this.props.add) {
      const { tableData } = this.state;
      const prevRows = tableData.rows;
      tableData.rows = [];
      
      for (const factura of this.props.facturas) {
        if (prevRows.find(f => f.id === factura.id)) {
          continue;
        }
        for (let prop in factura) {
					if (prop !== 'id' && isDate(factura[prop])) {
						factura[prop] = moment(factura[prop]).format('D/M/YYYY HH:mm');
					}
				}
        tableData.rows.push({ ...factura });
      }

      tableData.rows.push(...prevRows);

      if (this.deleteRow) {
        tableData.rows = tableData.rows.filter(r => r.id !== this.deleteRow.id)
      }

      this.rpp = 15;
      this.setState({
        tableData: {
          ...tableData,
          rows: tableData.rows,
          total: tableData.rows.length,
          rpp: 15,
        },
      });
      this.props.onAdd();
    }
  }

	dialogClose = async (op) => {
		this.setState({ dialog: { show: false }, loading: true });
		if (op === 1) {
      if (this.deleteRow.nueva) {
        this.deleteRow.delete = true;
        this.props.onDelete(this.deleteRow);
      } else {
        let Res = await Http.post(`${this.config.deleteUrl}`, this.deleteRow);
        if (!Res.error) {
          this.table();
        }
      }
		}
		this.setState({ loading: false });
	}

  render() {
    return (
      <div>
        <this.TableRender />
      </div>
    );
  }
}

export default withRouter(FacturasClientes);
